import React from 'react';
import { usePanelHierarchy } from '../../../../modules/panel';

/**
 * HierarchyTab - Salt okunur ağaç görünümü
 * MainPanel → GT → THP/SP/OP... → ek panolar
 */
export default function HierarchyTab() {
  const { getHierarchyTree } = usePanelHierarchy();
  const tree = getHierarchyTree();

  return (
    <div className="hierarchy-tree">
      <div className="hierarchy-node">
        <div className="hierarchy-node-label" style={{ fontWeight: 600 }}>
          Ana Dağıtım Panosu (MainPanel)
        </div>
        <div className="hierarchy-children">
          {tree.map(panelType => (
            <HierarchyNode key={panelType.id} panelType={panelType} />
          ))}
        </div>
      </div>
    </div>
  );
}

function HierarchyNode({ panelType }) {
  return (
    <div className="hierarchy-node">
      <div className="hierarchy-node-label">
        <strong>{panelType.code}</strong> - {panelType.label}
        {panelType.defaultOutputs && panelType.defaultOutputs.length > 0 && (
          <span style={{ color: '#888', fontSize: 11, marginLeft: 6 }}>
            ({panelType.defaultOutputs.length} çıkış)
          </span>
        )}
      </div>
      {panelType.children && panelType.children.length > 0 && (
        <div className="hierarchy-children">
          {panelType.children.map(child => (
            <div key={child.id} className="hierarchy-node">
              <div className="hierarchy-node-label">
                <strong>{child.code}</strong> - {child.label}
                {child.defaultOutputs && child.defaultOutputs.length > 0 && (
                  <span style={{ color: '#888', fontSize: 11, marginLeft: 6 }}>
                    ({child.defaultOutputs.length} çıkış)
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
